"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx8 = _interopRequireDefault(require("clsx"));
var _context = _interopRequireDefault(require("../Theme/context"));
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["classNames", "Component", "ComponentProps", "long", "ui", "blackAndWhite", "viewBox", "classes", "effect", "autoStopTime", "animationStateInitially", "autoStopInitially"];
var defaultStyle = require("./../empty_css.js")["default"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useContext = (0, _react.useContext)(_context["default"]),
    _useContext$additiona = _useContext.additionalStyles,
    additionalStyles = _useContext$additiona === void 0 ? {} : _useContext$additiona,
    useStyle = _useContext.useStyle;
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? additionalStyles.logo || defaultStyle : _props$classNames,
    _props$Component = props.Component,
    Component = _props$Component === void 0 ? _Button["default"] : _props$Component,
    _props$ComponentProps = props.ComponentProps,
    ComponentProps = _props$ComponentProps === void 0 ? {} : _props$ComponentProps,
    _props$long = props["long"],
    _long = _props$long === void 0 ? false : _props$long,
    _props$ui = props.ui,
    ui = _props$ui === void 0 ? false : _props$ui,
    _props$blackAndWhite = props.blackAndWhite,
    blackAndWhite = _props$blackAndWhite === void 0 ? false : _props$blackAndWhite,
    _props$viewBox = props.viewBox,
    viewBox = _props$viewBox === void 0 ? _long ? !ui ? '0 0 317.45 42.12' : '0 0 103 42.12' : '0 0 49 42.12' : _props$viewBox,
    _props$classes = props.classes,
    classes = _props$classes === void 0 ? {} : _props$classes,
    effect = props.effect,
    _props$autoStopTime = props.autoStopTime,
    autoStopTime = _props$autoStopTime === void 0 ? 6000 : _props$autoStopTime,
    animationStateInitially = props.animationStateInitially,
    _props$autoStopInitia = props.autoStopInitially,
    autoStopInitially = _props$autoStopInitia === void 0 ? false : _props$autoStopInitia,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  if (classNames !== additionalStyles.logo) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  var container = (0, _react.useRef)();
  var icon = (0, _react.useRef)();
  var animationState = (0, _react.useRef)(typeof animationStateInitially === 'number' ? animationStateInitially : -1);
  var blackAndWhiteState = (0, _react.useRef)(blackAndWhite);
  function setBlackAndWhite(value) {
    if (blackAndWhiteState.current !== value) {
      blackAndWhiteState.current = value;
      if (icon.current) {
        icon.current.setAttribute('class', (0, _clsx8["default"])(classes.icon, classNames.icon, (0, _defineProperty2["default"])({}, classNames.blackAndWhite, blackAndWhiteState.current)));
      }
    }
  }
  var runAnimation = animationState.current;
  function _setRunAnimation(v) {
    animationState.current = v;
    runAnimation = animationState.current;
    if (container.actions) {
      container.actions.setClassName((0, _clsx8["default"])((0, _defineProperty2["default"])({}, classNames.runAnimation, runAnimation >= 0), (0, _defineProperty2["default"])({}, classNames.stopping, runAnimation === 0)));
    }
  }
  var timer = (0, _react.useRef)(0);
  function setRunAnimation(v) {
    var runAnimation = animationState.current;
    if (v !== runAnimation) {
      _setRunAnimation(v);
      if (v >= 0) {
        autoStop();
      }
    }
  }
  function autoStop() {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    if (autoStopTime) {
      timer.current = setTimeout(function () {
        clearTimeout(timer.current);
        var runAnimation = animationState.current;
        if (runAnimation >= 0) {
          setRunAnimation(-1);
        }
      }, autoStopTime);
    }
  }
  (0, _react.useEffect)(function () {
    if (autoStopInitially) {
      autoStop();
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: {
          setRunAnimation: setRunAnimation,
          setBlackAndWhite: setBlackAndWhite
        }
      });
    }
    return function () {
      if (effect) {
        effect({
          actions: {
            setRunAnimation: function setRunAnimation() {},
            setBlackAndWhite: function setBlackAndWhite() {}
          }
        });
      }
    };
  });
  var _ComponentProps$href = ComponentProps.href,
    href = _ComponentProps$href === void 0 ? '' : _ComponentProps$href,
    _ComponentProps$onCli = ComponentProps.onClick,
    onClick = _ComponentProps$onCli === void 0 ? null : _ComponentProps$onCli;
  return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({
    Component: !(href || onClick) ? 'span' : 'a'
  }, ComponentProps, {
    effect: function effect(_ref) {
      var actions = _ref.actions;
      container.actions = actions;
    },
    defaultClassName: (0, _clsx8["default"])(classNames.logo, ComponentProps.className, classes.root, (0, _defineProperty2["default"])({}, classNames.disablePointerEvents, !(href || onClick))),
    className: (0, _clsx8["default"])((0, _defineProperty2["default"])({}, classNames.runAnimation, runAnimation >= 0), (0, _defineProperty2["default"])({}, classNames.stopping, runAnimation === 0)),
    ref: ref,
    variant: 'text',
    size: 'none',
    ButtonBaseContentComponent: function ButtonBaseContentComponent() {
      return /*#__PURE__*/_react["default"].createElement("svg", Object.assign({
        xmlns: 'http://www.w3.org/2000/svg'
      }, rest, {
        viewBox: viewBox,
        className: (0, _clsx8["default"])(classNames.svg, rest.className)
      }), /*#__PURE__*/_react["default"].createElement("g", {
        className: (0, _clsx8["default"])(classes.icon, classNames.icon, (0, _defineProperty2["default"])({}, classNames.blackAndWhite, blackAndWhiteState.current)),
        ref: icon
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-1'],
        d: "M31.06,14.17H34.8a.61.61,0,0,0,.58-.48l1.23-6.44A.6.6,0,0,0,36,6.54h-6.2a.6.6,0,0,0-.58.71l1.23,6.44A.6.6,0,0,0,31.06,14.17Z",
        transform: "translate(-0.21 -2.94)"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-2'],
        d: "M21.32,13.66h19a0,0,0,0,1,0,0v10a0,0,0,0,1,0,0H22.37a1,1,0,0,1-1-1v-9a0,0,0,0,1,0,0Z",
        transform: "translate(61.4 34.39) rotate(-180)"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-3'],
        d: "M5.24,30.44h41.9a.65.65,0,0,0,.57-1l-4.77-8.82a.64.64,0,0,0-.57-.34H5.24a.65.65,0,0,0-.65.65v8.82A.65.65,0,0,0,5.24,30.44Z",
        transform: "translate(-0.21 -2.94)"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        className: classNames['cls-4'],
        points: "21.11 3.36 2.76 3.36 7.09 17.38 21.11 17.38 21.11 3.36"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        className: classNames['cls-2'],
        x: "0.21",
        y: "3.7",
        width: "22.24",
        height: "2.6",
        rx: "0.63",
        transform: "translate(22.45 7.06) rotate(-180)"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        className: classNames['cls-3'],
        cx: "13.53",
        cy: "13.43",
        r: "5.38",
        transform: "translate(-0.14 24) rotate(-89.9)"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        className: classNames['cls-5'],
        cx: "36.2",
        cy: "28.56",
        r: "4.92",
        transform: "matrix(0, -1, 1, 0, 7.38, 61.79)"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-1'],
        d: "M34.38,28.56a1.83,1.83,0,1,0,1.82-1.82A1.83,1.83,0,0,0,34.38,28.56Z",
        transform: "translate(-0.21 -2.94)"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        className: classNames['cls-5'],
        cx: "13.73",
        cy: "28.56",
        r: "4.92",
        transform: "translate(-15.06 39.32) rotate(-89.92)"
      })), /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-1'],
        d: "M11.91,28.56a1.83,1.83,0,1,0,1.82-1.82A1.82,1.82,0,0,0,11.91,28.56Z",
        transform: "translate(-0.21 -2.94)"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        className: classNames['cls-2'],
        x: "18.59",
        y: "15.33",
        width: "10.81",
        height: "47.13",
        rx: "1.18",
        transform: "translate(62.68 11.95) rotate(90)"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        className: classNames['cls-6'],
        x: "37.78",
        y: "37.72",
        width: "10.81",
        height: "2.35",
        transform: "translate(81.87 -7.23) rotate(90)"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        className: classNames['cls-6'],
        x: "33.63",
        y: "37.72",
        width: "10.81",
        height: "2.35",
        transform: "translate(77.72 -3.09) rotate(90)"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        className: classNames['cls-6'],
        x: "3.41",
        y: "37.72",
        width: "10.81",
        height: "2.35",
        transform: "translate(47.49 27.14) rotate(90)"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        className: classNames['cls-6'],
        x: "-0.74",
        y: "37.72",
        width: "10.81",
        height: "2.35",
        transform: "translate(43.35 31.29) rotate(90)"
      })), _long ? !ui ? /*#__PURE__*/_react["default"].createElement("g", {
        className: (0, _clsx8["default"])(classNames["long"], classes["long"])
      }, /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-3'],
        d: "M78.38,44.13a13.22,13.22,0,0,1-3.15.35c-.56,0-1.35,0-2.35-.09-.33,0-.94,0-1.82,0a17.91,17.91,0,0,1-2.13-3.17c-.63-1.17-1.32-2.63-2.09-4.37a6.13,6.13,0,0,1-.38-1,4.64,4.64,0,0,1-.15-.65l-.14-.53L66,34.05c0,1.51,0,3.39.08,5.64.06,1.84.09,3.3.09,4.39a13.73,13.73,0,0,1-3.72.45,17.74,17.74,0,0,1-4.09-.45q-.18-3.86-.18-8.74,0-5.28.14-10.52T58.45,13c1,0,2.35,0,4.13,0,.56,0,1.61.05,3.15.05,0,1.12,0,3.88,0,8.25v.89a47.71,47.71,0,0,0,2.4-4.26,44.9,44.9,0,0,1,3-5l2.93,0a22.56,22.56,0,0,1,4.26.23,20.45,20.45,0,0,1-1.46,3.7q-.93,1.85-2.62,4.77l-.26.45a47.48,47.48,0,0,0-3.24,6.12Z",
        transform: "translate(-0.21 -2.94)"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-3'],
        d: "M97.51,23.49l0,.8v.8c-.06,1-.09,2.41-.09,4.3,0,2.1,0,3.7-.14,4.8l-.13,1.46a12.75,12.75,0,0,1-1.82,6.13,5.6,5.6,0,0,1-2,1.64,14,14,0,0,1-2.93,1.15,13.42,13.42,0,0,1-3.86.49c-.68,0-1.15,0-1.42,0a11.58,11.58,0,0,1-3.88-1,5.15,5.15,0,0,1-2.51-2.28,11.37,11.37,0,0,1-1.15-5l-.09-1.42a14.12,14.12,0,0,1,0-1.46q-.23-3.65-.22-7c0-1.36,0-2.72.13-4.09a18.48,18.48,0,0,1,.78-4.32,10.52,10.52,0,0,1,2-3.71l1-.53a14.68,14.68,0,0,1,10.23-.82,10.33,10.33,0,0,1,3.31,1.62,7.11,7.11,0,0,1,2,2.79,14.42,14.42,0,0,1,.76,2.84C97.47,21.61,97.51,22.54,97.51,23.49Zm-17-14.91,0-.94V6.89l0-.49V6a9.9,9.9,0,0,1,1.53-.31A13.22,13.22,0,0,1,84,5.51a6.69,6.69,0,0,1,2.8.45,4.43,4.43,0,0,1,0,.71L86.64,8l-.23,2.8-5.72-.05A11.15,11.15,0,0,1,80.51,8.58Zm10,17-.18-2.31a5.42,5.42,0,0,0-.6-2.19,3.09,3.09,0,0,0-1.31-1.36,2,2,0,0,0-.71-.13,3.65,3.65,0,0,0-2.09.71,5.54,5.54,0,0,0-1,1.26,7.61,7.61,0,0,0-.78,1.67,23.43,23.43,0,0,0-.44,5c0,1,0,1.76.05,2.26v0a20.1,20.1,0,0,1,.26,2.35l0,.62a17.92,17.92,0,0,0,.48,3.29v-.05a2.92,2.92,0,0,0,1.18,1.36A3.18,3.18,0,0,0,87,38.4a3.51,3.51,0,0,0,1.45-.33,3.56,3.56,0,0,0,1.26-1,3.19,3.19,0,0,0,.56-1,5.28,5.28,0,0,0,.11-1.24,9.91,9.91,0,0,1,0-1.11l0-.58,0-.84v-.62l0-.85V28.77l-.09-3Zm-2.27-17,0-.94V6.89l0-.49V6a10.43,10.43,0,0,1,1.53-.31,13.24,13.24,0,0,1,1.85-.14A6.67,6.67,0,0,1,94.49,6a4.61,4.61,0,0,1,0,.71L94.36,8l-.22,2.8-5.73-.05A11.15,11.15,0,0,1,88.23,8.58Z",
        transform: "translate(-0.21 -2.94)"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-3'],
        d: "M110.47,40.49q-2.79-6.12-3.68-8.48v8.52c0,1.84,0,3.1,0,3.78a9.43,9.43,0,0,1-2.62.35c-.29,0-.74,0-1.33-.09s-1.12-.09-1.42-.09l-2.18-.09V41.07c0-1.9,0-4.59-.08-8.08q0-2.63,0-8,0-7.14.4-12a10.5,10.5,0,0,1,2.66-.31,19.13,19.13,0,0,1,2.38.18,4.71,4.71,0,0,1,1.93.53c.41.77.92,1.84,1.53,3.22s1.19,2.74,1.75,4.1l1.78,4.09q-.09-3.12-.09-7.33c0-2.28,0-3.84.05-4.7a19.85,19.85,0,0,1,3.86-.36,17.54,17.54,0,0,1,3.59.4V44.35a2.08,2.08,0,0,0-.53.13,4.61,4.61,0,0,1-1.55.18,19.5,19.5,0,0,1-2.36-.13l-1.35-.09a4.34,4.34,0,0,0-1,0Z",
        transform: "translate(-0.21 -2.94)"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-3'],
        d: "M125.65,44.39c-.44,0-1.05,0-1.82.09l-1.87.05a17.92,17.92,0,0,1-2-.14q1.06-3.2,4.09-11l1.82-4.62a30.59,30.59,0,0,0-1.11-3.48c-.45-1.14-1-2.5-1.69-4.06-.8-2-1.4-3.51-1.8-4.58a29.53,29.53,0,0,1-1-3.37,18.72,18.72,0,0,0,2.62-.13,18.39,18.39,0,0,1,2.08-.18,5.13,5.13,0,0,1,2.58.58c.26,1.09.67,2.45,1.22,4.08s1.07,3.08,1.57,4.35c.15-.29.63-1.64,1.43-4,.88-2.66,1.39-4.11,1.5-4.35A25.07,25.07,0,0,1,138,13.1a16.3,16.3,0,0,1,2.58.18A60.62,60.62,0,0,1,138,21q-1.56,3.7-4.22,9.3-2.13,4.35-3.55,7.61t-2.53,6.64A16.27,16.27,0,0,0,125.65,44.39Z",
        transform: "translate(-0.21 -2.94)"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-3'],
        d: "M156.85,27.88q-1.72,6.93-4.35,16.51a12.33,12.33,0,0,0-1.33,0l-.44,0a14.8,14.8,0,0,1-1.65.09,14.17,14.17,0,0,1-4.35-.53,157.19,157.19,0,0,1-5.19-30,3,3,0,0,1,1.64-.66,15.55,15.55,0,0,1,2.76-.23,19.43,19.43,0,0,1,3.19.31l.27,3.95c.17,2.93.37,5.47.57,7.62s.51,4.27.89,6.37c.36-1.63.9-4.59,1.64-8.88q1.33-7.86,1.78-9.37a19.48,19.48,0,0,0,3.95.36,18.88,18.88,0,0,1,3.15.18H160Q158.58,21,156.85,27.88Z",
        transform: "translate(-0.21 -2.94)"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-2'],
        d: "M187.92,44.31c-1.3,0-3.22,0-5.77.08l-5.81,0q-4,0-7.9-.27c0-.94,0-4.63-.14-11.05-.09-3.64-.13-6.43-.13-8.39q0-6.07.31-11.32l3.91-.13c4.37-.18,7.72-.27,10-.27,2,0,3.9.08,5.77.23a12.49,12.49,0,0,1,.17,2.17c0,.45,0,1.17-.08,2.18s-.09,1.68-.09,2.22a28.55,28.55,0,0,1-5.95.57l-5.77.05a33.09,33.09,0,0,0-.22,3.46,6.1,6.1,0,0,0,.26,1.86l2.93-.35c.42,0,1,0,1.87.09l.57,0a17.36,17.36,0,0,1,.23,2.89L182,32a14.91,14.91,0,0,1-3.82.4l-1.15,0a.6.6,0,0,0-.4.09l-.18,2.31a21,21,0,0,0,.18,3c1.53,0,3,0,4.48.13L183,38c.74,0,1.62,0,2.62,0l2.71-.09c.06,1.37.09,2.15.09,2.36A15.11,15.11,0,0,1,187.92,44.31ZM183.75,8a13.09,13.09,0,0,0-3,3.07,22.75,22.75,0,0,1-2.75.13c-.83,0-1.68-.05-2.55-.13a14.94,14.94,0,0,1-2-.31,38.2,38.2,0,0,0,3-2.93,68.41,68.41,0,0,1,5.19-4.93l3.6,3.77Z",
        transform: "translate(-0.21 -2.94)"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-2'],
        d: "M205.41,23.71a13.32,13.32,0,0,1-3.82-.49,3.58,3.58,0,0,0,.09-.62,2.12,2.12,0,0,0-.76-1.68,2.44,2.44,0,0,0-1.68-.67,1.73,1.73,0,0,0-1.78,1.69,2.19,2.19,0,0,0-.13.71l0,.4v.08a2.2,2.2,0,0,0,.91,1.29,4,4,0,0,0,1.45.49,12.17,12.17,0,0,1,4.48,1.64,12.75,12.75,0,0,1,3.64,3.11,10,10,0,0,1,1.33,2.55,8.12,8.12,0,0,1,.49,2.73,10.43,10.43,0,0,1-1,4.48,8.53,8.53,0,0,1-3.55,3.87,10.43,10.43,0,0,1-5.24,1.37,14.65,14.65,0,0,1-5.62-1.13,10.83,10.83,0,0,1-4.41-3.26,6.94,6.94,0,0,1-1.51-4.93v-.4a16.55,16.55,0,0,1,2.84-.22c.89,0,1.64,0,2.26,0s1.57.05,3,.05a2.93,2.93,0,0,0,.82,2.08,2.49,2.49,0,0,0,1.8.76,2.05,2.05,0,0,0,1.49-.58,2.16,2.16,0,0,0,.6-1.64,3.2,3.2,0,0,0-.05-.62,2.81,2.81,0,0,0-1.55-2.31,14.83,14.83,0,0,0-3.6-1.11l-.66-.13A7.13,7.13,0,0,1,192,29.7a10.65,10.65,0,0,1-2.4-3.33,8.59,8.59,0,0,1-.8-3.55,9.42,9.42,0,0,1,1.76-5.43,10.1,10.1,0,0,1,4.55-3.71,11.4,11.4,0,0,1,4.3-.71,14.72,14.72,0,0,1,6.08,1.24,8.87,8.87,0,0,1,3.24,2.8,7,7,0,0,1,1.2,4.08,12.89,12.89,0,0,1-.27,2.31h-.53A22,22,0,0,1,205.41,23.71Z",
        transform: "translate(-0.21 -2.94)"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-5'],
        d: "M237.68,14.83c0,1.34,0,3.39.08,6.17l.05,1.74c.06,1.77.09,3.22.09,4.34s0,2-.05,2.53c0,.39,0,1,0,1.82a48.36,48.36,0,0,1-.4,5.42,10.48,10.48,0,0,1-1.49,4.08,6.74,6.74,0,0,1-3.62,2.8v0A11.51,11.51,0,0,1,227,44.79a16.58,16.58,0,0,1-3.46-.35A7,7,0,0,1,219,40.16a19.23,19.23,0,0,1-1.36-7.39l0-.67v-.75a13.32,13.32,0,0,1,3.46-.36,24.65,24.65,0,0,1,4.75.44v.36q.36,4.71,2.13,4.84a1.13,1.13,0,0,0,1.31-.69,5.92,5.92,0,0,0,.6-2.2q-.18-7.46-.18-12.56,0-4,.13-8.17v-.53l7.82-.09Z",
        transform: "translate(-0.21 -2.94)"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-5'],
        d: "M255.21,44.66a20.41,20.41,0,0,1-4.26-.49c-.21-.56-.54-1.74-1-3.55A25.93,25.93,0,0,0,248.91,37l-.89,0-.76,0a26.74,26.74,0,0,0-.57,2.62,28.67,28.67,0,0,1-.63,2.82,7,7,0,0,1-.88,2,7.28,7.28,0,0,1-1.33.09q-.4,0-1.74-.09c-2.57-.11-4-.17-4.3-.17q0-.22.09-1c.06-.54.15-1.16.26-1.84l1-5.59q1.16-6.89,2.2-12T244.07,13a12.22,12.22,0,0,1,1.68-.09H246c1.92,0,3.8-.07,5.64-.22.35,1.39.68,2.76,1,4.11s.57,2.55.8,3.61c.95,4.12,1.58,6.85,1.91,8.21l2.93,15.76A14.17,14.17,0,0,1,255.21,44.66ZM253.57,8a13.09,13.09,0,0,0-3,3.07,22.87,22.87,0,0,1-2.75.13c-.83,0-1.68-.05-2.55-.13a15.15,15.15,0,0,1-2-.31,39.78,39.78,0,0,0,3-2.93,68.41,68.41,0,0,1,5.19-4.93l3.59,3.77Zm-5.51,14.38,0-.44-.09,1.07c-.09,2.21-.22,4-.4,5.28l-.4,3H249Q248,22.42,248.06,22.42Z",
        transform: "translate(-0.21 -2.94)"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-5'],
        d: "M275.31,16A30.49,30.49,0,0,1,275,20.6a14.28,14.28,0,0,0-2.3-.26l-2.09-.05c-.77,0-1.15.05-1.15.14a23.19,23.19,0,0,0-.09,2.62q0,3.9.31,21a17.77,17.77,0,0,1-3,.23h-1.29a24.52,24.52,0,0,0-4.08.31,2.39,2.39,0,0,1-.2-.91,6.82,6.82,0,0,1,0-1.27V40.27l0-4q0-8.07-.35-15.75a3.41,3.41,0,0,0-1.38-.23l-1.78.05a7.86,7.86,0,0,1-2.17-.22,5.52,5.52,0,0,1-.22-1.47c-.06-.8-.09-1.7-.09-2.71,0-1.48,0-2.54,0-3.19h1.91l1.73-.05h2.49l2.57,0a95.22,95.22,0,0,1,10.79.49h.58C275.28,14.15,275.31,15.1,275.31,16Z",
        transform: "translate(-0.21 -2.94)"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-5'],
        d: "M295.86,44.31c-1.3,0-3.22,0-5.77.08l-5.81,0c-2.63,0-5.27-.09-7.9-.27,0-.94,0-4.63-.13-11.05-.09-3.64-.14-6.43-.14-8.39,0-4.05.11-7.82.31-11.32l3.91-.13q6.57-.27,10-.27c2,0,3.91.08,5.77.23a11.51,11.51,0,0,1,.18,2.17c0,.45,0,1.17-.09,2.18s-.09,1.68-.09,2.22a28.48,28.48,0,0,1-5.95.57l-5.77.05a33.09,33.09,0,0,0-.22,3.46,5.79,5.79,0,0,0,.27,1.86l2.93-.35q.62,0,1.86.09l.58,0a17.41,17.41,0,0,1,.22,2.89L290,32a14.91,14.91,0,0,1-3.82.4l-1.15,0a.6.6,0,0,0-.4.09l-.18,2.31a21,21,0,0,0,.18,3c1.54,0,3,0,4.48.13l1.87.09c.74,0,1.61,0,2.62,0l2.7-.09c.06,1.37.09,2.15.09,2.36A15.11,15.11,0,0,1,295.86,44.31ZM291.69,8a12.76,12.76,0,0,0-3,3.07,22.87,22.87,0,0,1-2.75.13c-.83,0-1.68-.05-2.56-.13a14.94,14.94,0,0,1-2-.31,38.2,38.2,0,0,0,3-2.93,66.31,66.31,0,0,1,5.2-4.93l3.59,3.77Z",
        transform: "translate(-0.21 -2.94)"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        className: classNames['cls-5'],
        d: "M317.66,44.13a13.22,13.22,0,0,1-3.15.35c-.57,0-1.35,0-2.36-.09-.32,0-.93,0-1.82,0a17.91,17.91,0,0,1-2.13-3.17q-.93-1.76-2.08-4.37a5.33,5.33,0,0,1-.38-1,5.64,5.64,0,0,1-.16-.65l-.13-.53-.18-.58q0,2.27.09,5.64c.06,1.84.09,3.3.09,4.39a13.81,13.81,0,0,1-3.73.45,17.71,17.71,0,0,1-4.08-.45q-.18-3.86-.18-8.74c0-3.52.05-7,.13-10.52s.14-7.5.14-11.85c1,0,2.35,0,4.13,0,.56,0,1.61.05,3.15.05,0,1.12,0,3.88,0,8.25v.89a47.71,47.71,0,0,0,2.4-4.26,42,42,0,0,1,3-5l2.93,0a22.56,22.56,0,0,1,4.26.23,20.45,20.45,0,0,1-1.46,3.7c-.62,1.23-1.5,2.82-2.62,4.77l-.27.45A50.11,50.11,0,0,0,310,28.28Z",
        transform: "translate(-0.21 -2.94)"
      })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(60, 30)",
        className: (0, _clsx8["default"])(classNames.ui, classes.ui, classNames['cls-3'])
      }, /*#__PURE__*/_react["default"].createElement("text", null, "UI"))) : null);
    }
  }));
});